module.exports = __webpack_public_path__ + "img/2arrow.4a187296.svg";